import { createHook, createStore } from 'react-sweet-state';

const Store = createStore({
  initialState: {
    isLoading: true,
    message: 'Cargando...',
  },
  actions: {
    setLoading: (isLoading) => {
      return ({ setState }) => {
        setState({
          isLoading,
        });
      };
    },
  },
  name: 'loadingScreen',
});
const hook = createHook(Store);

export const useLoadingScreen = () => {
  const [state, actions] = hook();
  return [state, actions];
};
